import { Button } from '@mr-yum/frontend-ui'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { useLoggerLegacy } from '@/hooks/useLogger'

interface Props {
  venueSlug: string
}

export const BookNowButton = (_props: Props) => {
  const { logEventLegacy } = useLoggerLegacy()
  return (
    <Button
      type="button"
      variant="primary-alternative"
      onClick={() => {
        logEventLegacy('Clicked on Booking')
      }}
      fullWidth
    >
      <FormattedMessage defaultMessage="Make a booking" id="ZIbSua" />
    </Button>
  )
}
